import { j as e } from "./jsx-runtime-944c88e2.js";
import { Icon as i } from "./icon.js";
import { Typography as t } from "./typography.js";
import { g as o } from "./funFacts-4c7657d3.js";
import "react";
import "./index-efd35e77.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
const h = /* @__PURE__ */ e.jsxs(
  "div",
  {
    style: {
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      minHeight: "max(60vh, 16em)",
      justifyContent: "center",
      width: "80%",
      margin: "auto"
    },
    children: [
      /* @__PURE__ */ e.jsx(i, { icon: "message-exclamation", size: "8x" }),
      /* @__PURE__ */ e.jsx(t.H1, { style: { paddingTop: ".5em" }, children: "We're sorry! You don't have access to this application." }),
      /* @__PURE__ */ e.jsx(t.H2, { style: { paddingTop: "1em" }, children: "Please request Okta access from User Support." })
    ]
  }
);
function g() {
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        minHeight: "max(60vh, 16em)",
        justifyContent: "center",
        width: "80%",
        margin: "auto"
      },
      children: [
        /* @__PURE__ */ e.jsx(i, { icon: "message-exclamation", size: "8x" }),
        /* @__PURE__ */ e.jsx(t.H1, { style: { paddingTop: "1em" }, children: "We're sorry! This page does not exist." }),
        /* @__PURE__ */ e.jsxs(t.H2, { style: { paddingTop: "1em" }, children: [
          "Random fact of the moment... ",
          /* @__PURE__ */ e.jsx(t.P, { style: { paddingTop: ".5em" }, children: o() })
        ] })
      ]
    }
  );
}
export {
  g as NotFound,
  h as UnauthorizedLogin
};
